<template>
  <div class="schedule__item" v-if="order">
    <div class="row">
      <div class="col-12 col-lg-3 col-xl-3">
        <div
          class="schedule__item-img"
          :style="{
            background: `linear-gradient(135deg, ${event} 0%,${primary} 50%,${secondary} 100%)`
          }"
        >
          <img
            :src="order.Product.image ? order.Product.image : defaultImage"
            :alt="order.Product.name"
          />
        </div>
        <br />
      </div>
      <div class="col-12 col-lg-5 col-xl-6">
        <p class="schedule__item-name">
          {{ order.Product.name }}
        </p>
        <p>Package: {{ order.Term.name }}</p>
        <p>Start: {{ formatDate(order.OrderPackage.startAt) }}</p>
        <p>End: {{ formatDate(order.OrderPackage.endAt) }}</p>

        <!-- <p>Additional Person:</p> -->
      </div>
      <div class="col-12 col-lg-4 col-xl-3 text-right">
        <p class="mb-20">
          Php
          {{ cost }}
        </p>
        <button
          class="btn btn-outline-primary p-10 mr-10"
          @click="onEditSchedule()"
        >
          <i class="fa fa-edit"></i>
        </button>
        <button class="btn btn-outline-danger p-10" @click="onRemoveSchedule()">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "@/helpers/moment";
export default {
  data: () => ({
    defaultImage: require("@/assets/media/backgrounds/default.jpg")
  }),
  props: {
    order: {
      type: [Object],
      default: null
    },
    index: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    cost() {
      return this.order.OrderPackage.total.toLocaleString("en-US", {
        minimumFractionDigits: 2
      });
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MMMM DD, YYYY h:mm A");
    },
    ...mapActions({
      ORDER_REMOVE_SCHEDULE: "ORDER_REMOVE_SCHEDULE"
    }),
    onEditSchedule() {
      const editSchedule = {
        index: this.index,
        data: {
          ...this.order,
          ...{
            progress: "productDetails"
          }
        }
      };
      this.$emit("onEditSchedule", editSchedule);
    },
    onRemoveSchedule() {
      this.$swal({
        title: "Are you sure you want to delete this order?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.ORDER_REMOVE_SCHEDULE({ index: this.index });
          this.$swal("Deleted!", "Order has been deleted.", "success");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.schedule {
  &__item {
    margin-bottom: 60px;
    &-img {
      width: 100%;
      overflow: hidden;
      border-radius: 10px;
      position: relative;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        z-index: 1;
      }
    }
    &-name {
      font-size: 18px !important;
      color: #232323;
    }
    &:last-child {
      margin-bottom: 0px !important;
    }
    p,
    li {
      margin: 0;
      font-size: 15px;
    }
  }
}
</style>
